export const NAME = 'sideStapleMachines';